import React, { useState } from "react";
import { IoCloseOutline, IoInformationCircleOutline } from "react-icons/io5";
import { ImageComponent } from "../global/imageComponent";
import {
  CustomAccordionBody,
  CustomAccordionHeader,
  CustomAccordionItem,
  CustomAccordionWrapper,
} from "../global/customAccordion";
import FavRecentMatchCard from "../common/FavRecentMatchCard";
import BuilderSlider from "../pages/staightPage/builderSlider";
import CustomRangeComponent from "../pages/staightPage/customRangeComponent";
import CalculatorModel from "../pages/staightPage/calculatorModel";
import CallBetsBetBuilderPanel from "../pages/staightPage/CallBetsBetBuilderPanel";
import CallBetSlipBuilder from "../pages/staightPage/CallBetSlipBuilder";
import {
  useBetSlip,
  PARLAY_MIN_LEGS,
  formatAmericanOdds,
} from "../../context/BetSlipProvider";
import { useBetBuilderFavoritesRecents } from "../../hooks/useBetBuilderFavoritesRecents";
import {
  buildBuyPointSelectOptions,
  canShowBuyPointsUI,
  findBuyPointOptionIndex,
} from "../../utility/buyPointOptions";
import {
  formatBetSlipPoint,
  formatOdds,
  formatPoint,
  formatTotalPoint,
} from "../../utility/odds";
import { formatMoney } from "../lib/wagerFinancials";
import { formatEventKickoffUpperCase } from "../lib/dateFormat";
import {
  formatTeaserAmericanOddsDisplay,
  formatTeaserChartLabel,
  getTeaserAmericanOdds,
} from "../../utility/teaserOdds";
import { resolveCallBetPriceForPayout } from "../../utility/callBetDisplay";
import { useCoinMode } from "../../context/CoinModeContext";
import { formatWagerAmount } from "../../utility/wagerDisplay";
import { isDTS } from "../../utility/platform";
import {
  getBuyPointsLabel,
  getEntryTypeLabel,
  getFeaturedMarketLabel,
  getTerm,
} from "../../utility/complianceCopy";
import {
  parlayMinLegsMessage,
  prizeAmountLabel,
  teaserMoneylineBlockedMessage,
} from "../../utility/entryCopy";
import AcceptOddsChangesControl from "./AcceptOddsChangesControl";
import "../pages/staightPage/staightPage.css";

export default function BetBuilderPanel() {
  const { coinMode } = useCoinMode();
  const wagerAmount = (amount) => formatWagerAmount(formatMoney(amount), coinMode);
  const {
    betTabName,
    setBetTabName,
    CheckInd,
    buyPointsMap,
    totalBet,
    totalTeaserBet,
    teaserPoints,
    setTeaserPoints,
    supportedTeaserPoints,
    teaserChartResult,
    teaserChartKey,
    calcTeaserPayout,
    settotalTeaserBet,
    totalRisk,
    totalWin,
    parlayCombinedOdds,
    parlayHasValidLegPrices,
    parlayDisplayPayout,
    handleRemoveTab,
    handleNumberInput,
    straightpayOutCalc,
    handlePoints,
    handleParlayChange,
    updateAllTeaserItems,
    addNewOrder,
    acceptOddsChanges,
    setAcceptOddsChanges,
    MAX_BET_DIGITS,
    MAX_BET_AMOUNT,
    BET_SLIP_INDEX,
    updateDesiredLine,
    updateDesiredPrice,
    callBetListRefreshKey,
  } = useBetSlip();

  const {
    sidebarFavorites,
    sidebarRecents,
    sportIconMaps,
    handleFavRecentGameSelect,
    handleClearAllRecents,
    handleRemoveRecentGame,
  } = useBetBuilderFavoritesRecents();

  const [isOpen, setIsOpen] = useState(false);
  const slip = CheckInd?.[BET_SLIP_INDEX] || [];

  return (
    <>
      <div className="betBuildContainer">
        <div>
          <button
            className="mg-primary-btn fs14"
            style={{ pointerEvents: "none" }}
            type="button"
          >
            {isDTS() ? `${getTerm("entry")} Builder` : "Bet Builder"}
          </button>
        </div>
        <div className="my-2">
          <BuilderSlider
            getCurrentSelectValue={setBetTabName}
            activeTab={betTabName}
          />
        </div>

        <div className="straightBetCardWrapper">
          {betTabName === "Straight Bet" && (
            <>
              <ul>
                {CheckInd && CheckInd?.[0]?.length > 0 ? (
                  CheckInd?.[0]?.map((item, index) => {
                    const pointOptions = buildBuyPointSelectOptions(item);
                    const buyPointIdx = findBuyPointOptionIndex(item, pointOptions);
                    const showBuyPoints = canShowBuyPointsUI(item, buyPointsMap);

                    return (
                      <li key={`straight-${index}`} className="straightBetCard">
                        <div className="leftPart">
                          <button
                            type="button"
                            onClick={() => handleRemoveTab(item, index)}
                          >
                            <IoCloseOutline />
                          </button>
                        </div>
                        <div className="rightPart">
                          <div>
                            <div className="mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <ImageComponent staticImgSrc="cricatIcon" />
                                <p className="fs12">{item.teamName}</p>
                              </div>
                              <div className="d-flex align-items-center gap-4 mt-1">
                                {item.type !== "h2h" ? (
                                  <p className="fs12 mb-0">
                                    {formatBetSlipPoint(item)}
                                  </p>
                                ) : null}
                                <p className="fs12 mb-0">
                                  {formatOdds(
                                    item.bookPrice ??
                                      item.originalPrice ??
                                      item.price
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="mb-1">
                            <label className="fs12 mg-test-gray1">
                              {getFeaturedMarketLabel(item.type, isDTS())}
                            </label>
                          </div>

                          {showBuyPoints ? (
                            <div className="mb-2 buy-points-options">
                              <div className="d-flex align-items-center gap-1 mb-1">
                                <label className="fs12 mg-test-gray1 mb-0">
                                  {getBuyPointsLabel(isDTS())}
                                </label>
                                <IoInformationCircleOutline
                                  className="fs14 mg-text-gray1"
                                  aria-hidden="true"
                                />
                              </div>
                              <select
                                className="w-100 inputStyle1 fs12"
                                value={buyPointIdx}
                                onChange={(e) => {
                                  const opt =
                                    pointOptions[Number(e.target.value)];
                                  if (opt) handlePoints(opt, index, 0);
                                }}
                              >
                                {pointOptions.map((opt) => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ) : null}

                          <div className="d-flex justify-content-between">
                            <p className="fs12 mg-text-gray1">
                              {item?.homeTeam} (vs) {item?.awayTeam}
                            </p>
                            <p className="fs12 mg-text-gray1">
                              {formatEventKickoffUpperCase(item?.gameTime)}
                            </p>
                          </div>

                          <div className="fs12 d-flex gap-2 my-2">
                            <input
                              className="riskAndWin"
                              type="text"
                              inputMode="numeric"
                              placeholder={`Risk - ${wagerAmount(0)}`}
                              maxLength={MAX_BET_DIGITS}
                              value={item?.risk > 0 ? item?.risk : ""}
                              onChange={(e) =>
                                handleNumberInput(e.target.value, (val) =>
                                  straightpayOutCalc(
                                    val,
                                    item.price,
                                    0,
                                    index,
                                    "risk"
                                  )
                                )
                              }
                            />
                            <input
                              className="riskAndWin"
                              type="text"
                              inputMode="numeric"
                              placeholder={`Win - ${wagerAmount(0)}`}
                              maxLength={MAX_BET_DIGITS}
                              value={item?.win ? item?.win : ""}
                              onChange={(e) =>
                                handleNumberInput(e.target.value, (val) =>
                                  straightpayOutCalc(
                                    val,
                                    item.price,
                                    0,
                                    index,
                                    "win"
                                  )
                                )
                              }
                            />
                          </div>

                          {item?.payout > 0 && (
                            <div className="fs14 d-flex gap-2 my-2">
                              <p className="mg-text-green1 fs14">
                                {prizeAmountLabel()} {wagerAmount(item.payout)}
                              </p>
                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <p className="fs12 mt-3 text-center">
                    Select Spread, {getFeaturedMarketLabel("h2h", isDTS())}, or Total from any match to <br />
                    {isDTS()
                      ? `add it to your ${getTerm("entry", { case: "lower" })} slip.`
                      : "add it to your bet slip."}
                  </p>
                )}
              </ul>
              {CheckInd && CheckInd?.[0]?.length > 0 ? (
                <>
                  <div className="d-flex justify-content-between gap-2 my-0">
                    <p className="fs12 mg-text-gray1">Total Risk</p>
                    <p className="fs12 riskAndWin">{wagerAmount(totalRisk)}</p>
                  </div>
                  <div className="d-flex justify-content-between gap-2 my-0">
                    <p className="fs12 mg-text-gray1">Total Win</p>
                    <p className="fs12 riskAndWin">{wagerAmount(totalWin)}</p>
                  </div>
                </>
              ) : null}
              <div className="py-2">
                {CheckInd && CheckInd?.[0]?.length > 0 ? (
                  <div>
                    <AcceptOddsChangesControl
                      checked={acceptOddsChanges}
                      onChange={setAcceptOddsChanges}
                    />
                    <button
                      type="button"
                      className="mg-primary-btn fs14"
                      onClick={() => addNewOrder(CheckInd[0], "straight")}
                    >
                      {isDTS() ? `Submit All ${getTerm("entry", { plural: true })}` : "Submit All Bet"}
                    </button>
                  </div>
                ) : null}
              </div>
            </>
          )}

          {betTabName === "Parlay Bet" && (
            <>
              <ul>
                <div className="rightPart">
                  <div className="d-flex gap-2 align-items-center justify-content-between" />
                </div>

                {CheckInd && CheckInd?.[0]?.length > 0 ? (
                  CheckInd[0]?.map((item, index) => (
                    <li key={`parlay-${index}`} className="straightBetCard">
                      <div className="leftPart">
                        <button
                          type="button"
                          onClick={() => handleRemoveTab(item, index)}
                        >
                          <IoCloseOutline />
                        </button>
                      </div>
                      <div className="rightPart">
                        <div>
                          <div className="mb-1">
                            <div className="d-flex align-items-center gap-2">
                              <ImageComponent staticImgSrc="cricatIcon" />
                              <p className="fs12">{item.teamName}</p>
                            </div>
                            <div className="d-flex align-items-center gap-4">
                              {item.type !== "h2h" ? (
                                <p className="fs12">{formatBetSlipPoint(item)}</p>
                              ) : null}
                              <p className="fs12">{formatOdds(item.price)}</p>
                            </div>
                          </div>

                          <div className="mb-2">
                            <label className="fs13 mg-text-gray1">
                              {getFeaturedMarketLabel(item.type, isDTS())}
                            </label>
                          </div>

                          <div className="d-flex justify-content-between">
                            <p className="fs12 mg-text-gray1">
                              {item?.homeTeam} (vs) {item?.awayTeam}
                            </p>
                            <p className="fs12 mg-text-gray1">
                              {formatEventKickoffUpperCase(item?.gameTime)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <p className="fs12 mt-3 text-center">
                    Select Spread, {getFeaturedMarketLabel("h2h", isDTS())}, or Total from any match to <br />
                    {isDTS()
                      ? `add it to your ${getTerm("entry", { case: "lower" })} slip.`
                      : "add it to your bet slip."}
                  </p>
                )}
              </ul>
              {CheckInd && CheckInd?.[0]?.length > 0 ? (
                <div className="py-2">
                  <div className="parlay-slip-footer">
                    <div className="parlay-slip-footer__meta">
                      <span className="parlay-slip-footer__legs">
                        {CheckInd[0].length} Legs
                      </span>
                      <span className="parlay-slip-footer__odds">
                        Odds{" "}
                        <strong>
                          {CheckInd[0].length >= PARLAY_MIN_LEGS &&
                          parlayHasValidLegPrices
                            ? formatAmericanOdds(parlayCombinedOdds)
                            : "—"}
                        </strong>
                      </span>
                    </div>
                    <input
                      className="inputStyle2 parlay-slip-footer__stake"
                      placeholder={wagerAmount(0)}
                      value={totalBet ?? ""}
                      onChange={(e) => handleParlayChange(e.target.value)}
                    />
                  </div>

                  {CheckInd[0].length >= PARLAY_MIN_LEGS &&
                    !parlayHasValidLegPrices && (
                      <p className="fs11 text-center text-warning mb-2">
                        One or more legs are missing valid odds.
                      </p>
                    )}

                  {CheckInd[0].length < PARLAY_MIN_LEGS && (
                    <p className="fs11 text-center text-danger mb-2">
                      {parlayMinLegsMessage(PARLAY_MIN_LEGS)}
                    </p>
                  )}

                  <div className="parlay-slip-payout-row">
                    <p className="mg-text-green1 fs12 mb-0">
                      {prizeAmountLabel()} {wagerAmount(parlayDisplayPayout)}
                    </p>
                    <button
                      type="button"
                      onClick={() => setIsOpen(true)}
                      className="fs11 cursor-pointer text-decoration-underline parlay-slip-calc-link"
                    >
                      {isDTS()
                        ? `${getEntryTypeLabel("Parlay", true)} Calculator`
                        : "Parlay Calculator"}
                    </button>
                  </div>

                  <div>
                    <AcceptOddsChangesControl
                      checked={acceptOddsChanges}
                      onChange={setAcceptOddsChanges}
                    />
                    <button
                      type="button"
                      className="mg-primary-btn fs14"
                      disabled={
                        CheckInd[0].length < PARLAY_MIN_LEGS ||
                        !parlayHasValidLegPrices ||
                        !Number(totalBet) ||
                        Number(totalBet) <= 0
                      }
                      onClick={() => addNewOrder(CheckInd[0], "parlay")}
                    >
                      {isDTS() ? `Submit All ${getTerm("entry", { plural: true })}` : "Submit All Bet"}
                    </button>
                  </div>
                </div>
              ) : null}
            </>
          )}

          {betTabName === "Teaser" && (
            <>
              {Array.isArray(CheckInd?.[0]) && CheckInd[0].length > 0 ? (
                <>
                  <ul>
                    <li className="straightBetCard teaser-slip-header-row" aria-hidden="true">
                      <div className="leftPart">
                        <button type="button" tabIndex={-1} disabled>
                          <IoCloseOutline />
                        </button>
                      </div>
                      <div className="rightPart teaser-slip-row">
                        <div className="teaser-slip-columns">
                          <ImageComponent staticImgSrc="cricatIcon" />
                          <div className="teaser-slip-team" />
                          <div className="teaser-slip-metrics fs13">
                            <p className="mb-0">Original</p>
                            <p className="mb-0">Points</p>
                            <p className="mb-0">New Line</p>
                          </div>
                        </div>
                      </div>
                    </li>

                    {CheckInd[0].map((item, ind) => (
                      <li key={ind} className="straightBetCard">
                        <div className="leftPart">
                          <button
                            type="button"
                            onClick={() => handleRemoveTab(item, ind)}
                          >
                            <IoCloseOutline />
                          </button>
                        </div>

                        <div className="rightPart teaser-slip-row">
                          <div className="teaser-slip-columns">
                            <ImageComponent staticImgSrc="cricatIcon" />
                            <div className="teaser-slip-team">
                              <p className="fs12 mb-0 text-truncate">
                                {item.teamName}
                              </p>
                            </div>
                            <div className="teaser-slip-metrics">
                              <p className="fs12 text-secondary mb-0">
                                {item.originalPoint !== undefined &&
                                item.originalPoint !== null &&
                                item.originalPoint !== "" &&
                                item.originalPoint !== "-"
                                  ? item.type === "totals"
                                    ? formatTotalPoint(
                                        item.originalPoint,
                                        item.pointType || item.teamName
                                      )
                                    : formatPoint(item.originalPoint)
                                  : "-"}
                              </p>
                              <p className="fs12 text-success fw-bold mb-0">
                                {item.type === "h2h"
                                  ? "-"
                                  : Number.isFinite(Number(item.buyPoints))
                                    ? item.buyPoints
                                    : teaserPoints}
                              </p>
                              <p className="fs12 mb-0">
                                {item.type === "h2h" ||
                                !Number.isFinite(Number(item.adjustedPoint))
                                  ? "-"
                                  : item.type === "totals"
                                    ? formatTotalPoint(
                                        item.adjustedPoint,
                                        item.pointType || item.teamName
                                      )
                                    : formatPoint(item.adjustedPoint)}
                              </p>
                            </div>
                          </div>

                          <div className="pt-2">
                            <p className="fs12 mg-text-gray1 mb-1">
                              {getFeaturedMarketLabel(item.type, isDTS())}
                            </p>
                            <div className="d-flex justify-content-between">
                              <p className="fs12 mg-text-gray1">
                                {item.homeTeam} (vs) {item.awayTeam}
                              </p>
                              <p className="fs12 mg-text-gray1">
                                {formatEventKickoffUpperCase(item?.gameTime)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <div>
                    {(() => {
                      const hasH2H = CheckInd[0].some((i) => i.type === "h2h");
                      const teamCount = CheckInd[0].length;

                      if (teamCount < 2) {
                        return (
                          <p className="fs12 mt-3 text-center text-danger">
                            Select at least two teams to continue.
                          </p>
                        );
                      }

                      if (hasH2H) {
                        return (
                          <p className="fs12 mt-3 text-center text-danger">
                            {teaserMoneylineBlockedMessage()}
                          </p>
                        );
                      }

                      return null;
                    })()}

                    {CheckInd[0].length > 1 && (
                      <>
                        <CustomRangeComponent
                          value={teaserPoints}
                          allowedValues={supportedTeaserPoints}
                          onChange={(val) => {
                            setTeaserPoints(val);
                            updateAllTeaserItems(
                              totalTeaserBet,
                              CheckInd[0].length,
                              val
                            );
                          }}
                        />

                        <div className="my-2 d-flex justify-content-between">
                          <div>
                            <p className="fs13 mb-0">
                              {CheckInd[0].length} Team{" "}
                              {Number.isFinite(Number(teaserPoints))
                                ? teaserPoints
                                : (supportedTeaserPoints[0] ?? 6)}{" "}
                              {isDTS()
                                ? getEntryTypeLabel("Teaser", true)
                                : "Point Teaser"}
                            </p>
                            {teaserChartResult.ok && (
                              <p className="fs11 text-secondary mb-0">
                                {formatTeaserChartLabel(teaserChartKey)} chart
                              </p>
                            )}
                          </div>

                          <div className="w-25 d-flex gap-2 align-items-center justify-content-between">
                            <p className="fs13">
                              {formatTeaserAmericanOddsDisplay(
                                getTeaserAmericanOdds(
                                  teaserChartKey,
                                  CheckInd[0].length,
                                  teaserPoints
                                )
                              )}
                            </p>
                            <div className="fs14">
                              <input
                                type="text"
                                inputMode="decimal"
                                placeholder={wagerAmount(0)}
                                className="inputStyle2 w-100"
                                maxLength={MAX_BET_DIGITS + 3}
                                value={totalTeaserBet}
                                onChange={(e) => {
                                  const nextValue = e.target.value;
                                  if (nextValue === "") {
                                    settotalTeaserBet("");
                                    return;
                                  }
                                  if (!/^\d*\.?\d*$/.test(nextValue)) return;
                                  const intPart =
                                    nextValue.split(".")[0] || "";
                                  if (intPart.length > MAX_BET_DIGITS) return;
                                  if (Number(nextValue) > MAX_BET_AMOUNT) return;
                                  updateAllTeaserItems(
                                    nextValue,
                                    CheckInd[0].length,
                                    teaserPoints
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="mt-2 d-flex justify-content-between">
                          <p className="mg-text-gray1 fs13">Total Stake</p>
                          <p className="fs13">
                            {wagerAmount(totalTeaserBet || 0)}
                          </p>
                        </div>

                        <div className="my-2 d-flex justify-content-between">
                          <p className="mg-text-gray1 fs13">{isDTS() ? `Total ${getTerm("prize")}` : "Total Payout"}</p>
                          <p className="fs13">
                            {wagerAmount(
                              calcTeaserPayout(
                                Number(totalTeaserBet) || 0,
                                CheckInd[0].length,
                                teaserPoints
                              )
                            )}
                          </p>
                        </div>

                        <div className="pt-3">
                          <AcceptOddsChangesControl
                            checked={acceptOddsChanges}
                            onChange={setAcceptOddsChanges}
                          />
                          <button
                            type="button"
                            className="mg-primary-btn fs14"
                            disabled={
                              CheckInd[0].length < 2 ||
                              CheckInd[0].some((i) => i.type === "h2h")
                            }
                            onClick={() => addNewOrder(CheckInd[0], "teaser")}
                          >
                            {isDTS() ? `Submit All ${getTerm("entry", { plural: true })}` : "Submit All Bet"}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <p className="fs12 mt-3 text-center">
                  {isDTS() ? `Please select ${getTerm("play", { case: "lower" })} teams` : "Please select betting teams"}
                </p>
              )}
            </>
          )}

          {betTabName === "Call Bets" && (
            <>
              <CallBetSlipBuilder
                items={CheckInd?.[0] || []}
                totalRisk={totalRisk}
                totalWin={totalWin}
                maxBetDigits={MAX_BET_DIGITS}
                onRemove={handleRemoveTab}
                onDesiredLineChange={updateDesiredLine}
                onDesiredPriceChange={updateDesiredPrice}
                onRiskChange={(val, price, g, i) =>
                  handleNumberInput(val, (v) =>
                    straightpayOutCalc(v, price, g, i, "risk")
                  )
                }
                onWinChange={(val, price, g, i) =>
                  handleNumberInput(val, (v) =>
                    straightpayOutCalc(v, price, g, i, "win")
                  )
                }
                onSubmit={() => addNewOrder(CheckInd[0], "straight")}
              />
              <hr className="call-bet-divider" />
              <CallBetsBetBuilderPanel
                isActive={betTabName === "Call Bets"}
                refreshKey={callBetListRefreshKey}
              />
            </>
          )}
        </div>

        <div className="recentAccordionWrapper">
          <hr className="recentHrTag" />
          <CustomAccordionWrapper multiple defaultOpen={[]}>
            <CustomAccordionItem id="favoritesItem" className="">
              <CustomAccordionHeader className="recentItemHeader">
                <div className="d-flex align-items-center gap-2">
                  <ImageComponent staticImgSrc="favoritesIcon" />
                  <p className="fs13 fw-400">Favorites</p>
                </div>
              </CustomAccordionHeader>
              <CustomAccordionBody
                className="favRecentAccordionBody"
                scrollMaxHeight={280}
              >
                {sidebarFavorites.length > 0 ? (
                  sidebarFavorites.map((item) => (
                    <FavRecentMatchCard
                      key={`fav-${item.id}`}
                      item={item}
                      sportIconMaps={sportIconMaps}
                      onOpen={handleFavRecentGameSelect}
                    />
                  ))
                ) : (
                  <p className="fs12 text-center my-3 recent-empty-msg">
                    No favorite matches
                  </p>
                )}
              </CustomAccordionBody>
            </CustomAccordionItem>
            <CustomAccordionItem id="recentsItem" className="" autoScroll>
              <CustomAccordionHeader className="recentItemHeader">
                <div className="d-flex align-items-center justify-content-between w-100 pe-2">
                  <div className="d-flex align-items-center gap-2">
                    <ImageComponent staticImgSrc="favoritesIcon" />
                    <p className="fs13 fw-400">Recents</p>
                  </div>
                  {sidebarRecents.length > 0 && (
                    <button
                      type="button"
                      className="recent-clear-all-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClearAllRecents();
                      }}
                    >
                      Clear All
                    </button>
                  )}
                </div>
              </CustomAccordionHeader>
              <CustomAccordionBody
                className="favRecentAccordionBody"
                scrollMaxHeight={280}
              >
                {sidebarRecents.length > 0 ? (
                  sidebarRecents.map((item) => (
                    <FavRecentMatchCard
                      key={`recent-${item.id}`}
                      item={item}
                      sportIconMaps={sportIconMaps}
                      onOpen={handleFavRecentGameSelect}
                      onRemove={handleRemoveRecentGame}
                    />
                  ))
                ) : (
                  <p className="fs12 text-center my-3 recent-empty-msg">
                    Select Spread, {getFeaturedMarketLabel("h2h", isDTS())}, or Total from a match to add it here
                  </p>
                )}
              </CustomAccordionBody>
            </CustomAccordionItem>
          </CustomAccordionWrapper>
        </div>
      </div>

      <CalculatorModel
        show={isOpen}
        setShow={setIsOpen}
        mode={betTabName === "Parlay Bet" ? "parlay" : "straight"}
        selections={CheckInd?.flat() || []}
        onRemoveSelection={(item, index) => handleRemoveTab(item, index)}
        onApplyRisk={(amount) => {
          if (betTabName === "Parlay Bet") {
            handleParlayChange(String(amount));
            return;
          }
          const flat = CheckInd?.flat() || [];
          flat.forEach((it, i) => {
            if (it?.price !== undefined && it?.price !== null) {
              const payoutPrice =
                betTabName === "Call Bets"
                  ? resolveCallBetPriceForPayout(it) ?? it.price
                  : it.price;
              straightpayOutCalc(amount, payoutPrice, 0, i, "risk");
            }
          });
        }}
      />
    </>
  );
}
